<script>
import InterlayerPage from '@/components/Report/InterlayerPage';
import AnalysisSection from '@/components/Export/Analysis/Section';
import Banner from '@/components/Export/Analysis/Banner';

export default {
  components: {
    InterlayerPage,
    AnalysisSection,
    Banner,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    comment: {
      type: String,
      default: null,
    },

    filters: {
      type: String,
      default: null,
    },

    pageCount: {
      type: Number,
      default: 0,
    },

    name: {
      type: String,
      default: null,
    },

    site: {
      type: [Object, Array],
      default: () => ({}),
    },

    study: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    transportMode() {
      return this.data.transportMode;
    },

    sites() {
      return this.data.sites;
    },
  },

  methods: {
    enumerable(size) {
      size = size || 5;
      const count = Math.ceil(this.sites.length / size) || 1;
      const enumerable = [];
      for (let i = 0; i < count; i++) {
        enumerable.push([i * size, i * size + size]);
      }
      return enumerable;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/A4.scss';
@use '@/styles/colors.scss';

.page {
  width: 297mm;
  height: 209mm;
  background-color: white;
  box-sizing: border-box;
  page-break-after: always;
  display: flex;
  flex-direction: column;

  margin: 64px auto;
  border-radius: 4px;
  overflow: hidden;
  box-shadow:
    0 4px 24px 0 rgba(0, 0, 0, 0.1),
    0 4px 8px -4px rgba(0, 0, 0, 0.4);
}
.page :deep(.table-body) .table-row:nth-child(n + 5) {
  display: flex;
}
.page :deep(.impact-summary-container) .impact-block {
  max-width: 189px;
}
.report-view {
  flex: 1;
}
h2 {
  font-size: 24px * A4.$ratio;
  font-weight: 600;
  color: #3c3c3b;
  flex-direction: column;

  &:after {
    content: ' ';
    display: block;
    margin-top: 5px * A4.$ratio;
    width: 25px * A4.$ratio;
    height: 2px;
    background-color: #bc141a;
    margin-bottom: 13px * A4.$ratio;
  }
}
h5 {
  font-weight: 300;
  margin: 0;
  color: #000000;
  font-size: 24px * A4.$ratio;
}

@media print {
  .page {
    transform: scale(1);
    margin: 0;
    border-radius: 0;
    box-shadow: none;
  }
}

.proportion-legend {
  width: calc(100% - 24px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 0 12px;
  border-top: solid 1px colors.$grey-color;

  .label {
    &.improvement {
      color: #1daea1;
    }
    &.degradation {
      color: colors.$red-color;
    }
  }
  .cercle {
    $radius: 20px;
    margin: 2px 8px;
    width: $radius;
    height: $radius;
    border-radius: $radius;
    border: solid 4px transparent;
    border-top-color: #1daea1;
    border-left-color: #1daea1;
    border-right-color: colors.$red-color;
    border-bottom-color: colors.$red-color;
    transform: rotate(-45deg);
  }
}
</style>
